import { useMutation, useQueryClient } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { sendToApi } from 'api/client'
import { UseMutationOptions } from 'react-query/types/react/types'
import { Data } from 'hooks/queries/workspaces/useCreateBrandVisualKit'
import { reportError } from 'utils/error'
import { buildErrorMessage } from 'utils'

interface Props {
  id: number
}

export type Options = Omit<UseMutationOptions<Data>, 'mutationKey' | 'mutationFn'>

export const deleteFont = async ({ workspaceId, id }: Props & { workspaceId: number }) => {
  const response = await sendToApi(`/w/${workspaceId}/fonts/${id}`, {
    method: 'DELETE',
  })

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    reportError('Failed to delete font', {
      metaData: {
        id,
        response: response.data,
      },
    })
    throw new Error(
      buildErrorMessage(response.data.errors) ||
        'An error occurred! Our team has been notified and we are looking into it.',
    )
  }
  return response.data
}

export const useDeleteFont = ({ id }: Props, options?: Options) => {
  const queryClient = useQueryClient()
  const currentWorkspaceId = useCurrentWorkspaceId()
  return useMutation(
    ['workspaces', currentWorkspaceId, 'fonts', id],
    () => deleteFont({ workspaceId: currentWorkspaceId, id }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['workspaces', currentWorkspaceId, 'fonts', 'list'])
      },
      ...options,
    },
  )
}
